<script setup lang="ts">
    import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import { UserCompany } from '@/types';
    import EditUserCompany from './EditUserCompany.vue';

    interface Props {
        userCompany: UserCompany;
    }

    defineProps<Props>();
</script>

<template>
    <DataTableActions :data="userCompany">
        <EditUserCompany :user-company="userCompany" />
    </DataTableActions>
</template>
